import { ThemeProvider } from "@emotion/react";
import { LinearProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import NormalButton from "components/atoms/Button/NormalButton";
import React from 'react';



const colortheme = createTheme({
    palette: {
        primary: {
            main: "#292739",
        },
    },
    typography: {
        fontFamily: ["lato"].join(","),
    },
});

const ParaText = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: "#ffffff",
}));

const SmallText = styled(Typography)(({ theme }) => ({
    fontSize: ".8rem",
    color: "#ffffff",
}));

const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: "2.4rem",
    fontWeight: "bold",
    color: "#ffffff",
}));

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
    borderRadius: 5,
    backgroundColor: "#4d4b5a",
    '& .MuiLinearProgress-bar': {
        backgroundColor: "#ddb930",
    },
}));

const ButtonFooter = () => {

    return (
        <React.Fragment>
            <ThemeProvider theme={colortheme}>
                <Box>
                    <TitleText style={{ margin: "1rem 0", fontSize: "1.6rem" }}>
                        Welcome to Buku AVM!
                    </TitleText>
                    <ParaText style={{ color: "#c1c1c1" }}>
                        AVM (Ad Viewership Money) is money you earn from
                        watching ads on our platform. By continuing to use
                        our platform and enjoying creators content you will
                        also directly support your favorite creators.
                    </ParaText>

                    <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                        <Grid item xs={12}>
                            <NormalButton text={"Create Wallet"} color={"yellow"} style={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={12}>
                            <NormalButton text={"Earned-334 AVM"} style={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={12}>
                            <NormalButton text={"Withdraw AVM"} style={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={12}>
                            <NormalButton text={"Disable Payouts"} style={{ width: "100%" }} />
                        </Grid>
                    </Grid>

                    <Grid container style={{ margin: "2rem 0rem" }}>
                        <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                            <ParaText>
                                Next Pay out
                            </ParaText>
                        </Grid>

                        <Grid item xs={12}>
                            <CustomLinearProgress
                                variant="determinate"
                                value={40}
                            />
                            <SmallText style={{ color: "#c1c1c1" }}>
                                6 DAYS LEFT
                            </SmallText>
                        </Grid>
                    </Grid>

                    <Grid container style={{ justifyContent: "space-between", margin: "1.8rem 0px", gap: "1rem", }}>
                        <Grid item xs={12}>
                            <NormalButton style={{ width: "100%" }}>
                                Share my rewards
                            </NormalButton>
                        </Grid>
                    </Grid>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    );
};

export default ButtonFooter;
